module.exports = __webpack_public_path__ + "static/media/campusconectado.efdf39ca.svg";